import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ReactNode } from 'react';
import NotificationsRealtimeBridge from '@/components/Notifications/NotificationsRealtimeBridge';
import { DynamicThemeProvider } from './context/DynamicThemeProvider';
import { AuthProvider } from './context/AuthProvider';

interface Props {
  readonly children: ReactNode;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10000,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false
    },
    mutations: {
      retry: false
    }
  }
});

export default function AllProviders({ children }: Props) {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <NotificationsRealtimeBridge />
          <DynamicThemeProvider>{children}</DynamicThemeProvider>
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
